﻿import { onEvent } from "./_dom";
/*
 * There is a <select> with list of tables and multiple pickers
 * one for each table, identified by id="{baseName}_{position}"
 */
function onTogglePickers(event) {
	const select = event.target;
	const baseName = select.dataset.controlId;
	const filters = JSON.parse(select.dataset.tablePickerTables);
	const n = filters.length;
	const form = select.form;
	const selected = select.selectedIndex;
	const baseSelector = "#" + baseName + "_";

	// --None--, <table list>, --Unknown--
	const hasUnknownOption = select.options.length > n + 1;
	const unknownOptionIndex = n + 1;

	// Reset {baseName} value, with notify
	let el;
	el = form.elements[baseName];
	if (el.value !== "") {
		el.value = "";
		el.dispatchEvent(new Event("change", { bubbles: true }));
	}

	// Reset other values notify
	el = form.elements[baseName + "_text"];
	if (el) el.value = "";
	el = form.elements[baseName + "_filter"];
	if (el) el.value = selected >= 1 && selected <= n ? filters[selected - 1] : "";

	// Hide pickers other than selected
	for (let i = 1; i <= n; i++) {
		if (i != selected)
			form.querySelector(baseSelector + i).classList.add("hide");
	}
	// Hide "unknown" picker
	if (hasUnknownOption && unknownOptionIndex != selected) {
		form.querySelector(baseSelector + unknownOptionIndex).classList.add("hide");
	}
	// If selected other than --None--?
	// Show picker, reset value
	if (selected !== 0) {
		var recordPicker = form.querySelector(baseSelector + selected);
		recordPicker.classList.remove("hide");
		if (recordPicker.matches("select")) {
			recordPicker.selectedIndex = 0;
		} else if (recordPicker.matches("nobr.v3-typeinpicker")) {
			recordPicker.querySelector("input.v3-typeinpicker__input").value = "";
		} else if (recordPicker.matches("ul.v3-checklist")) {
			const radio = recordPicker.querySelector("input[type=radio]:checked");
			if(radio) radio.checked = false;
		}
	}
}

function init(context, selector = "[data-table-picker-tables]") {
	onEvent(context, selector, "change", onTogglePickers);
}

export { init };